import React, { useMemo, useState } from 'react';
import { Chess } from 'chess.js';
import ChessBoardView from '@/components/chess/ChessBoardView';
import StockfishPanel from '@/components/chess/StockfishPanel';
import CoachPanel from '@/components/chess/CoachPanel';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { RotateCcw, Copy, Upload } from 'lucide-react';

export default function ChessLab() {
  const [game, setGame] = useState(new Chess());
  const [orientation, setOrientation] = useState('white');
  const [fenInput, setFenInput] = useState('');

  const onDrop = (from, to) => {
    const tmp = new Chess(game.fen());
    try {
      const mv = tmp.move({ from, to, promotion: 'q' });
      if (!mv) return false;
      setGame(tmp);
      return true;
    } catch { return false; }
  };

  const reset = () => setGame(new Chess());
  const flip = () => setOrientation(o => o === 'white' ? 'black' : 'white');
  const undo = () => { const t = new Chess(game.fen()); t.undo(); setGame(new Chess(t.fen())); };
  const loadFen = () => {
    try {
      const t = new Chess(fenInput.trim());
      setGame(t);
      toast.success('FEN cargado');
    } catch { toast.error('FEN inválido'); }
  };
  const copyFen = () => { navigator.clipboard.writeText(game.fen()); toast.success('FEN copiado'); };
  const copyPgn = () => { navigator.clipboard.writeText(game.pgn()); toast.success('PGN copiado'); };

  const history = game.history();

  return (
    <div className="p-8 max-w-6xl mx-auto">
      <div className="mb-6">
        <h1 className="font-display text-4xl font-extrabold" data-testid="chess-lab-title">Tablero</h1>
        <p className="text-slate-500 mt-1">Practica libremente. Carga FEN, analiza con Stockfish o exporta PGN.</p>
      </div>
      <div className="grid lg:grid-cols-5 gap-8">
        <div className="lg:col-span-3">
          <ChessBoardView fen={game.fen()} onPieceDrop={onDrop} boardWidth={560} orientation={orientation}/>
          <div className="mt-4 flex flex-wrap gap-2">
            <Button data-testid="chess-reset" onClick={reset} variant="outline" className="rounded-full"><RotateCcw className="w-4 h-4 mr-1"/> Reiniciar</Button>
            <Button onClick={flip} variant="outline" className="rounded-full">Girar tablero</Button>
            <Button onClick={undo} variant="outline" className="rounded-full">Deshacer</Button>
            <Button onClick={copyFen} variant="outline" className="rounded-full"><Copy className="w-4 h-4 mr-1"/> FEN</Button>
            <Button onClick={copyPgn} variant="outline" className="rounded-full"><Copy className="w-4 h-4 mr-1"/> PGN</Button>
          </div>
        </div>
        <div className="lg:col-span-2 space-y-4">
          <StockfishPanel fen={game.fen()} depth={15}/>
          <CoachPanel fen={game.fen()} last_move={history[history.length-1]} pgn={game.pgn()}/>
          <div className="rounded-2xl bg-white border border-slate-200 p-4">
            <div className="text-xs uppercase tracking-widest text-slate-500 font-bold mb-2">Historial</div>
            <div className="font-mono text-sm text-slate-700 max-h-40 overflow-y-auto">
              {history.length === 0 ? <span className="text-slate-400">Sin movimientos</span> : history.join(' ')}
            </div>
          </div>
          <div className="rounded-2xl bg-white border border-slate-200 p-4">
            <div className="text-xs uppercase tracking-widest text-slate-500 font-bold mb-2">Cargar FEN</div>
            <div className="flex gap-2">
              <Input data-testid="fen-input" value={fenInput} onChange={(e)=>setFenInput(e.target.value)} placeholder="rnbqkbnr/…"/>
              <Button onClick={loadFen} className="rounded-full bg-slate-900 hover:bg-slate-800"><Upload className="w-4 h-4"/></Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
